import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import ErrorIconSvg from './exclamation-circle.svg';
import errorIconStyles from './ErrorIcon.css';
import defaultSvgAttributes from './defaultSvgAttributes.js';

const ErrorIcon = ({className, ...props}) => (
  <ErrorIconSvg
    {...defaultSvgAttributes}
    {...props}
    className={classNames(errorIconStyles.errorIcon, className)}
    preserveAspectRatio="xMidYMid meet"
  />
);

ErrorIcon.propTypes = {
  className: PropTypes.string
};

export default ErrorIcon;
